// src/components/HospitalDashBoardCards.jsx
import React, { useEffect, useState } from "react";
import { Card, Typography, CardActionArea, Box, Button, TextField, Stack, useTheme, useMediaQuery } from "@mui/material";
import { decrypt } from "../components/cryptoUtil";

import SP_ActiveUsers from "../pages/DashBoard/SuperUserDashBoard/SP_ActiveUsers";
import SP_SystemHealth from "../pages/DashBoard/SuperUserDashBoard/SP_SystemHealth";
import SP_Button_ChangeSoftware from "../pages/DashBoard/SuperUserDashBoard/SP_Button_ChangeSoftware";
import SP_Button_AddOrganisation from "../pages/DashBoard/SuperUserDashBoard/SP_Button_AddOrganisation";
import EncryptDecryptTool from "../components/EncryptDecryptTool";

const DashboardCards = ({
  cards = [],
  welcomeMessage,
  cardColors = [],
  onMenuClick,
  menulabel = 0, // 0 = root/master
  onActiveChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const tokenData = JSON.parse(decrypt(localStorage.getItem("tokenData") || "{}"));

  const [internalPath, setInternalPath] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const activePath = internalPath;
  const setActivePath = setInternalPath;

  const activeCard = activePath.length ? activePath[activePath.length - 1] : null;
  const childCards = activeCard?.children || [];
  const breadcrumb = activePath.length === 0 ? "Home" : ["Home", ...activePath.map(c => c.title)].join(" > ");
  const cardsToShow = activeCard ? childCards : cards;

  const filteredCards = cardsToShow.filter(card => card.title.toLowerCase().includes(searchQuery.toLowerCase()));

  const groupedCards = filteredCards.reduce((groups, card) => {
    const category = card.category || "Others";
    if (!groups[category]) groups[category] = [];
    groups[category].push(card);
    return groups;
  }, {});









  const colors = cardColors.length ? cardColors : [
    "linear-gradient(135deg, #1976d2, #42a5f5)",
    "linear-gradient(135deg, #2e7d32, #66bb6a)",
    "linear-gradient(135deg, #d32f2f, #ef5350)",
    "linear-gradient(135deg, #6a1b9a, #ab47bc)",
  ];

  const handleCardClick = (card) => {
    setActivePath(prev => [...prev, card]);
    if (onMenuClick) onMenuClick(true);
  };

  const handleBack = () => {
    setActivePath(prev => prev.slice(0, prev.length - 1));
    if (onMenuClick) onMenuClick(activePath.length - 1 > 0);
  };

  // Notify master whether we are at root
  useEffect(() => {
    const isRoot = activePath.length === 0;
    if (onActiveChange) onActiveChange(isRoot);
  }, [activePath, onActiveChange]);

  const DashboardWidgets = () => (
    <>
      <SP_ActiveUsers />
      {tokenData.userrole === 999 && (
        <>
          <SP_SystemHealth />
          <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3, mb: 3, mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              🚀 Quick Actions
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "center" }}>
              <SP_Button_ChangeSoftware />
              <SP_Button_AddOrganisation />
              <EncryptDecryptTool />
            </Stack>
          </Card>
        </>
      )}
    </>
  );





  return (
    <>
      {/* Breadcrumb */}
      <Box sx={{ mb: .5 }}>
        <Typography variant="subtitle2" color="textSecondary">{breadcrumb}</Typography>
      </Box>

      {/* If final component */}
      {activeCard && childCards.length === 0 ? (
        <Box sx={{ p: .5 }}>
          <Button variant="contained" color={activePath.length === 1 && menulabel === 0 ? "error" : "primary"} sx={{ mb: .5 }} onClick={handleBack}>
            {activePath.length === 1 && menulabel === 0 ? "Back to Dashboard" : "Back to Previous Menu"}
          </Button>
          {activeCard.component}
        </Box>
      ) : (
        <>
          {/* Welcome message only at root */}
          {!activeCard && menulabel === 0 && welcomeMessage && (
            <Box sx={{ backgroundColor: "#af7456", color: "white", borderRadius: 2, p: 1, mb: 2 }}>
              {typeof welcomeMessage === "string" ? <Typography variant="h5" align="center">{welcomeMessage}</Typography> : welcomeMessage}
            </Box>
          )}

          {/* Search */}
         {!activeCard && menulabel === 0  && (
  <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
    <TextField
      size="small"
      label="Search modules..."
      variant="outlined"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{ width: { xs: "100%", sm: "50%" }, backgroundColor: "white", borderRadius: 1 }}
    />
  </Box>
)}

          {/* Render grouped cards */}
          {Object.keys(groupedCards).length > 0 ? (
            Object.entries(groupedCards).map(([category, cardsInCategory], catIdx) => (
              <Box key={catIdx} sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ mb: 2, textAlign: "left", color: "#333", fontWeight: "bold" }}>
                  {category}
                </Typography>

                <Box sx={{ display: "flex", justifyContent: "flex-start", gap: { xs: 1, sm: 3 }, flexWrap: "wrap" }}>
                  {cardsInCategory.map((card, index) => (
                    <Card key={index} sx={{
                      borderRadius: 4,
                      boxShadow: 4,
                      textAlign: "center",
                      background: colors[index % colors.length],
                      color: "white",
                      flex: "1 1 200px",
                      maxWidth: 250,
                      minWidth: 180,
                      height: { xs: 50, sm: 100 },
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      "&:hover": { transform: "scale(1.05)", transition: "0.3s" }
                    }}>
                      <CardActionArea sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", p: 1 }} onClick={() => handleCardClick(card)}>
                        {!isMobile && <Box sx={{ mb: 1 }}>{card.icon}</Box>}
                        <Typography variant="h6" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" }, wordWrap: "break-word", overflowWrap: "break-word" }}>
                          {card.title}
                        </Typography>
                      </CardActionArea>
                    </Card>
                  ))}
                </Box>
              </Box>
            ))
          ) : (
            <Typography variant="body1" sx={{ mt: 2 }}>❌ No matching modules found.</Typography>
          )}
        </>
      )}

      {/* Widgets at root */}
      {menulabel === 0 && activePath.length === 0 && <DashboardWidgets />}
    </>
  );
};

export default DashboardCards;
